import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import tokenStorage from "../utils/tokenStorage";
import Loader from "../component/Loader";

const PrivateRoute = ({ children }) => {
  const { user, cargando, estaAutenticado } = useAuth();

  if (cargando) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  if (!user || !estaAutenticado || !tokenStorage.getAccessToken()) {
    return <Navigate to="/login" replace state={{ from: window.location.pathname }} />;
  }

  return children || <Outlet />;
};

export default PrivateRoute;
